export const CompletionStatusColDefs = {
  DIVISION: {},
  PARTICIPANT_COUNT: {},
  COMPLETION_PERCENTAGE: {},
  EMPLOYEE: {
    valueGetter: (params) => {
      const { data } = params;
      return data.EMPLOYEE?.displayName || '';
    },
    filter: 'agSetColumnFilter',
  },
  MANAGER: {
    valueGetter: (params) => {
      const { data } = params;
      return data.MANAGER?.displayName || '';
    },
    filter: 'agSetColumnFilter',
  },
};
